import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';

import MealPlans from '../pages/MealPlans/MealPlans';
import Menu from '../pages/MealPlans/Menu';
import Step1 from '../pages/MealPlans/Step1';
import Step2 from '../pages/MealPlans/Step2';
import Step3 from '../pages/MealPlans/Step3';
import Preview from '../pages/MealPlans/Preview';
import Checkout from '../pages/MealPlans/Checkout';
import CheckoutSuccess from '../pages/MealPlans/CheckoutSuccess';

import CorporateMeals from '../pages/CorporateMeals/CorporateMeals';
import Blog from '../pages/Blog/Blog';
import OurSuppliers from '../pages/OurSuppliers/OurSuppliers';
import MyAccount from '../pages/Account/MyAccount';
import TermsAndConditions from '../pages/TermsAndConditions/TermsAndConditions';
import Faq from '../pages/Faq/Faq';
import GiftCards from '../pages/GiftCards/GiftCards';
import GiftCardsRedeem from '../pages/GiftCards/components/GiftCardRedeem';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import ProtectedRoute from './ProtectedRoute';
import NoLogRoute from './NoLogRoute';
import GAPageTracker from '../components/GAPageTracker/GAPageTracker';
import GiftCardsSelector from '../pages/GiftCards/components/GiftCardsSelector';
import PromoSignup from '../pages/Promotions/Promo_250/PromoSignup';
import ThankYou from '../pages/Promotions/Promo_250/ThankYou';
import Vitasoy from '../pages/Promotions/Vitasoy/Vitasoy';
import NewBrand from '../pages/Promotions/newBrand/newbrand';
import WeightMgmt from '../pages/Promotions/weightManagement/weightMgmt';
import Promo from '../pages/Promotions/promo/promo';

export default () => (
  <Router>
    <Routes>
      <Route path="/" element={<MealPlans />} />
      <Route path="/:locale/Blog" element={<Blog />} />
      <Route path="/:locale/corporate-meals/" element={<CorporateMeals />} />
      <Route path="/:locale/catering/" element={<CorporateMeals />} />
      <Route path="/:locale/Redeem" element={<GiftCardsRedeem />} />
      <Route path="/:locale" element={<MealPlans />} />
      <Route path="/:locale/home" element={<MealPlans />} />
      <Route path="/:locale/our-menu" element={<Menu />} />
      <Route path="/:locale/suppliers/" element={<OurSuppliers />} />
      <Route path="/:locale/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/:locale/PrivacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/:locale/MealPlans/1" element={<Step1 />} />
      <Route path="/:locale/MealPlans/:brand" element={<Step2 />} />
      <Route
        path="/:locale/Checkout"
        element={
          <ProtectedRoute redirectPath="/MealPlans/1">
            <Checkout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/:locale/AccountMembers"
        element={
          <ProtectedRoute>
            <MyAccount />
          </ProtectedRoute>
        }
      />
      <Route path="/:locale/Checkout/Success" element={<CheckoutSuccess />} />

      <Route
        path="/:locale/MealPlans/details/:brand/:goal/:days"
        element={<Preview />}
      />
      <Route
        path="/:locale/MealPlans/package/:brand/:goal"
        element={<Step3 />}
      />
      <Route
        path="/:locale/TermsAndConditions"
        element={<TermsAndConditions />}
      />
      <Route path="/:locale/promo/thankyou" element={<ThankYou />} />

      <Route path="/:locale/FAQ/" element={<Faq />} />
      <Route path="/:locale/gift-cards/" element={<GiftCards />} />
      <Route
        path="/:locale/gift-cards/gift-cards-selector/"
        element={<GiftCardsSelector />}
      />
      <Route path="/:locale(zh_HK|en)?" element={<MealPlans />} />
      <Route
        path="/:locale(zh_HK|en)?/promo"
        element={
          <NoLogRoute redirectPath="/:locale(zh_HK|en)?">
            <PromoSignup />
          </NoLogRoute>
        }
      />
      <Route path="/:locale(zh_HK|en)?/promo/thankyou" element={<ThankYou />} />
      {/* <Route path="/:locale(zh_HK|en)?/promo" element={<Promo />} /> */}
      <Route
        path="/:locale(zh_HK|en)?/landing-NoshxVitaSoy"
        element={<Vitasoy />}
      />
      <Route
        path="/:locale(zh_HK|en)?/landing-lean-and-green"
        element={<NewBrand />}
      />
      <Route
        path="/:locale(zh_HK|en)?/weight-management"
        element={<WeightMgmt />}
      />
      <Route path="/:locale(zh_HK|en)?/wm" element={<WeightMgmt />} />
      <Route path="/:locale(zh_HK|en)?/MealPlans/1" element={<Step1 />} />
      <Route path="/:locale(zh_HK|en)?/MealPlans/:brand" element={<Step2 />} />
      <Route
        path="/:locale(zh_HK|en)?/MealPlans/package/:brand/:goal"
        element={<Step3 />}
      />
      <Route
        path="/:locale(zh_HK|en)?/MealPlans/details/:brand/:goal/:days"
        element={<Preview />}
      />
      <Route path="/:locale(zh_HK|en)?/our-menu/" element={<Menu />} />
      <Route
        path="/:locale(zh_HK|en)?/Checkout"
        element={
          <ProtectedRoute redirectPath="/MealPlans/1">
            <Checkout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/:locale(zh_HK|en)?/Checkout/Success"
        element={<CheckoutSuccess />}
      />
      <Route
        path="/:locale(zh_HK|en)?/corporate-meals/"
        element={<Navigate to="/catering/" replace />}
      />
      <Route
        path="/:locale(zh_HK|en)?/catering/"
        element={<CorporateMeals />}
      />

      <Route path="/:locale/Blog" element={<Blog />} />
      {/* <Route path="/:locale(zh_HK|en)?/Blog" element={<Blog />} /> */}
      <Route path="/:locale(zh_HK|en)?/suppliers/" element={<OurSuppliers />} />
      <Route path="/:locale(zh_HK|en)?/gift-cards/" element={<GiftCards />} />

      <Route
        path="/:locale(zh_HK|en)?/gift-cards/gift-cards-selector/"
        element={<GiftCardsSelector />}
      />
      <Route path="/:locale(zh_HK|en)?/Redeem" element={<GiftCardsRedeem />} />
      <Route
        path="/:locale(zh_HK|en)?/AccountMembers"
        element={
          <ProtectedRoute>
            <MyAccount />
          </ProtectedRoute>
        }
      />
      <Route path="/:locale(zh_HK|en)?/FAQ/" element={<Faq />} />
      <Route
        path="/:locale(zh_HK|en)?/TermsAndConditions"
        element={<TermsAndConditions />}
      />
      <Route
        path="/:locale(zh_HK|en)?/privacypolicy"
        element={<PrivacyPolicy />}
      />
      <Route
        path="/:locale(zh_HK|en)?/PrivatePolicy"
        element={<Navigate to="/privacypolicy" replace />}
      />
      <Route path="/:locale(zh_HK|en)/" element={<MealPlans />} />
      <Route
        path="/:locale(zh_HK|en)?/"
        element={<Navigate to="/our-menu/" replace />}
      />
    </Routes>
    <GAPageTracker />
  </Router>
);
